import { X } from "lucide-react";
import LoginPage from "../pages/LoginPage";

export default function LoginModal({ onClose }) {
  return (
    <div className="fixed inset-0 z-50 flex items-center justify-center p-4">

      <div
        className="absolute inset-0 bg-black/60 backdrop-blur-sm"
        onClick={onClose}
      />

      <div className="
        relative
        w-full
        max-w-md
        overflow-hidden
        rounded-3xl
        bg-white
        shadow-2xl
      ">

        {/* Header */}
        <div className="
          bg-[#8FE3D9]
          px-8
          py-7
        ">

          <button
            onClick={onClose}
            className="
              absolute
              right-5
              top-5
              rounded-full
              p-2
              text-black/50
              hover:bg-black/10
              hover:text-black
              transition
            "
          >
            <X size={22}/>
          </button>


          <h2 className="
            text-2xl
            font-bold
            text-black
          ">
            Välkommen
          </h2>


          <p className="
            mt-2
            text-black/60
          ">
            Logga in för att fortsätta
          </p>

        </div>


        <div className="p-8">
          <LoginPage />
        </div>

      </div>

    </div>
  );
}